import { render, staticRenderFns } from "./CreateDelForm.vue?vue&type=template&id=267d2b64&"
import script from "./CreateDelForm.vue?vue&type=script&lang=js&"
export * from "./CreateDelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports